





































































































import { Component, Watch } from 'vue-property-decorator';
import MyTodoServices from '@/services/mytodo';
import { getRange } from '@/libs/time';
import AlertDetail from './alert-detail.vue';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import PageMixin from '@/mixins/page-mixin';
import AlertData from '../full/alert-data.vue';
@Component({
  components: { AlertDetail, AlertData }
})
export default class Todo extends mixins(DictMixin, PageMixin) {
  todoSrv = new MyTodoServices();
  created() {
    this.getAll();
  }

  count: any = {};
  async getAll() {
    let [startTime, endTime] = this.date;
    this.loading = true;
    this.count = await this.todoSrv.getHandleCount({ startTime, endTime });
    this.$emit('updateCount', 'handle', this.count.count1);
    this.params = { startTime, endTime };
    await this.getList();
    this.loading = false;
  }

  params: any = {};

  async getList() {
    let res = await this.todoSrv.getHandlePage({ ...this.params, page: this.page, limit: this.limit });
    this.dataSource = res.list.map((v: any) => {
      return {
        ...v,
        ...v.sourceAsMap
      };
    });
    this.total = res.totalCount;
  }

  async getCurrentList(type: number) {
    this.page = 1;
    let [startTime, endTime] = this.date;
    this.loading = true;
    if (type === 0) {
      this.params = { endTime, alertHandleDueDate: endTime };
    } else {
      this.params = { endTime, alertHandleDueDate_lt: endTime };
    }
    this.getList();
    this.loading = false;
  }

  date: any = getRange('total');
  @Watch('date')
  onDateChange() {
    this.getAll();
  }

  pagination = { showTotal: () => `共 ${this.dataSource.length} 条` };
  columns = [
    { title: '预警编号', dataIndex: 'alertCode' },
    { title: '触发决策模型名称', dataIndex: 'ruleName' },
    { title: '预警消息', dataIndex: 'alertMessage' },
    { title: '数据数量', width: 120, dataIndex: 'alertCount' },
    {
      title: '预警等级',
      dataIndex: 'alertLevel',
      scopedSlots: {
        customRender: 'alertLevel'
      }
    },
    { title: '预警日期', dataIndex: 'alertDate' },
    { title: '经办期限', dataIndex: 'alertHandleDueDate' },
    {
      title: '操作',
      dataIndex: 'action',
      width: 140,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
  dataSource = [];

  visible: boolean = false;
  detail: any = {};
  logs: any = {};
  async openDetail(record: any) {
    let res = await this.todoSrv.getInfo(record.alertCode);
    this.detail = res.alertInfoSource || record;
    this.logs = res;
    this.visible = true;
  }

  handleVisible: boolean = false;
  ignoreVisible: boolean = false;
  transferVisible: boolean = false;
  handleLog: string = '';
  transferDept: string = '';
  async submitHandle(type: 'handle' | 'ignore' | 'transfer') {
    if (this.loading) return false;
    if (!this.handleLog) {
      this.$message.error('请先输入理由');
      return false;
    }
    let params: any = {
      alertSign: type,
      alertCode: this.detail.alertCode,
      alertMessage: this.handleLog
    };
    if (type === 'transfer') {
      params.transferDept = this.transferDept;
    }
    this.loading = true;
    let res = await this.todoSrv.processHandleAlert(params);
    this.loading = false;
    if (res) {
      this.$message.success('操作成功');
      this.handleVisible = false;
      this.ignoreVisible = false;
      this.transferVisible = false;
      this.visible = false;
      this.handleLog = '';
      this.transferDept = '';
      this.getAll();
    }
  }

  infos: any = {};
  dataVisible: boolean = false;
  async openAlertData(record: any) {
    this.infos = record;
    this.dataVisible = true;
  }

  @Watch('transferVisible')
  @Watch('ignoreVisible')
  @Watch('handleVisible')
  onVisiblesChange() {
    this.handleLog = '';
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
